import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {TitleBar} from '../../../../design-system/organisms/TitleBar/TitleBar';
import {TitleBarType} from '../../../../design-system/organisms/TitleBar/TitleBarType.enum';
import {
  DependOnLoggedInSection,
  SchemeSection,
} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {useLogin} from '../../../../user/useLogin.hook';
import {CommonSectionProps} from '../../type';

export function RecentViewed({section, children}: CommonSectionProps) {
  const {title} = section;
  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);
  const scheme =
    'scheme' in section ? (section as SchemeSection).scheme : undefined;
  const {isLogin} = useLogin();
  const loggedInTitle =
    'loggedInTitle' in section &&
    (section as DependOnLoggedInSection).loggedInTitle &&
    isLogin
      ? (section as DependOnLoggedInSection).loggedInTitle
      : undefined;
  const loggedInScheme =
    'loggedInScheme' in section &&
    (section as DependOnLoggedInSection).loggedInScheme &&
    isLogin
      ? (section as DependOnLoggedInSection).loggedInScheme
      : undefined;
  return (
    <div
      className="relative"
      ref={ref}
      {...putTiaraObjectProps({
        viewimp_contents: {
          imp_id: 'shistory',
          layer1: '최근본작품',
        },
        click: {
          imp_id: 'shistory',
          layer1: '최근본작품',
          imp_provider: 'service',
        },
        customProps: {
          section_title: title,
          section_type: '최근본작품',
        },
      })}
    >
      <TitleBar
        className="mb-4pxr"
        type={TitleBarType.Main}
        title={loggedInTitle || title || undefined}
        scheme={loggedInScheme || scheme}
        onClickMore={e => LOG_CLICK_EVENT('더보기_클릭', e)}
        {...putTiaraObjectProps({
          eventMeta: {
            id: scheme,
            type: 'scheme',
            provider: '서비스',
          },
          customProps: {
            landing_path: 'library',
          },
          click: {
            layer1: '최근본작품',
            imp_id: 'shistory',
            imp_provider: 'service',
          },
        })}
      />
      {children}
    </div>
  );
}
